<div class="date-wrapper">
  <div class="input-wrapper year" matAutocompleteOrigin #origin="matAutocompleteOrigin" >
    <input
      matInput
      [formControl]="yearControl"
      [matAutocomplete]="yearAuto"
      [matAutocompleteConnectedTo]="origin"
      placeholder="Year"
      (blur)="onBlur(DatePickerType.YEAR)"
      (keydown)="blockTyping($event)"
      class="no-caret"
    >

    <mat-autocomplete #yearAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, DatePickerType.YEAR)">
      <mat-option *ngFor="let year of years()" [value]="year">
        {{ year }}
      </mat-option>
    </mat-autocomplete>
  </div>

  <div class="input-wrapper month" matAutocompleteOrigin #origin2="matAutocompleteOrigin">
    <input
      matInput
      [formControl]="monthControl"
      [matAutocomplete]="monthAuto"
      [matAutocompleteConnectedTo]="origin2"
      placeholder="Month"
      [disabled]="!yearControl.value"
      (blur)="onBlur(DatePickerType.MONTH)"
      (keydown)="blockTyping($event)"
      class="no-caret"
    >

    <mat-autocomplete #monthAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, DatePickerType.MONTH)">
      <ng-container  *ngFor="let month of months; let i = index">
        @if (i === 0) {
          <mat-option [value]="null">---</mat-option>
        } @else {
          <mat-option [value]="month">
            {{ month }}
          </mat-option>
        }
      </ng-container>
    </mat-autocomplete>
  </div>

  <div class="input-wrapper day" matAutocompleteOrigin #origin3="matAutocompleteOrigin">
    <input
      matInput
      [formControl]="dayControl"
      [matAutocomplete]="dayAuto"
      [matAutocompleteConnectedTo]="origin3"
      placeholder="Day"
      [disabled]="!monthControl.value"
      (blur)="onBlur(DatePickerType.DAY)"
      (keydown)="blockTyping($event)"
      class="no-caret"
    >

    <mat-autocomplete #dayAuto="matAutocomplete" (optionSelected)="onOptionSelected($event, DatePickerType.DAY)">
      <mat-option [value]="null"> --- </mat-option>
      <mat-option *ngFor="let day of days" [value]="day">
        {{ day }}
      </mat-option>
    </mat-autocomplete>
  </div>
</div>
